export function getBboxFromGeoJson(geojson) {
  // Initialize min and max values
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity

  geojson.features.forEach((feature) => {
    const geometry = feature.geometry

    if (geometry.type === 'Polygon') {
      // Handle Polygon type
      const coordinates = geometry.coordinates[0]
      coordinates.forEach((coord) => {
        const [lng, lat] = coord
        minX = Math.min(minX, lng)
        minY = Math.min(minY, lat)
        maxX = Math.max(maxX, lng)
        maxY = Math.max(maxY, lat)
      })
    } else if (geometry.type === 'MultiPolygon') {
      // Handle MultiPolygon type
      geometry.coordinates.forEach((polygon) => {
        polygon[0].forEach((coord) => {
          const [lng, lat] = coord
          minX = Math.min(minX, lng)
          minY = Math.min(minY, lat)
          maxX = Math.max(maxX, lng)
          maxY = Math.max(maxY, lat)
        })
      })
    }
  })

  // The resulting bbox as an array [minX, minY, maxX, maxY]
  const bbox = [minX, minY, maxX, maxY]
  return bbox
}


export function undefinedToZero(str) {
    if (typeof str === 'undefined') {
      return '0'
    } else {
      return str
    }
  }